export default "__VITE_ASSET__BdhwYQCK__"